<template>
  <div>
    <div class="view-order">
      <div class="bread">
        <router-link class="bread-item" to="/">上上签</router-link>
        <div class="bread-arrow">&gt;</div>
        <router-link class="bread-item" to="/orders">订单管理</router-link>
        <div class="bread-arrow">&gt;</div>
        <router-link class="bread-item" :to="'/orders/fliggyDetail/'+oid">订单详情</router-link>
      </div>

      <div class="order-main">
        <div class="main-header">
          <img src="../../../assets/imgs/ota-order/fliggy.png" alt="">
          <span>{{DM.ota_store_name}}</span></div>
        <div class="main-tips" v-if="DM.alert_desc">{{DM.alert_desc}}</div>

        <div class="main-item-box">
          <div class="box-header">
            <span class="header-title">商品信息</span>
            <el-button v-if="DM.alert_desc" type="primary" @click="bindProduct">重新绑定</el-button>
          </div>
          <div class="box-body">
            <div class="body-field">
              <label class="field-label">绑定商品编号</label>
              <p class="field-content">{{DM.visa_product_id}}</p>
            </div>
            <div class="body-field">
              <label class="field-label">绑定商品</label>
              <p class="field-content">{{DM.product_name}}</p>
            </div>
            <div class="body-field">
              <label class="field-label">飞猪商品</label>
              <p class="field-content">{{DM.item_title}}</p>
            </div>
            <div class="body-field">
              <label class="field-label">套餐名称</label>
              <p class="field-content">{{DM.sku_properties}}</p>
            </div>
          </div>
        </div>

        <div class="main-item-box">
          <div class="box-header">
            <span class="header-title">订单信息</span>
          </div>
          <div class="box-body">
            <div class="body-field">
              <label class="field-label">飞猪订单号</label>
              <p class="field-content"><span class="content-subtitle">主订单</span>{{DM.ota_order_id}}<span class="content-subtitle left-border">子订单</span>{{oid}}</p>
            </div>
            <div class="body-field">
              <label class="field-label">购买数量</label>
              <p class="field-content">{{DM.item_num}}</p>
            </div>
            <div class="body-field">
              <label class="field-label">订单状态</label>
              <p class="field-content">{{otaStatusMap[DM.ota_status]}}</p>
            </div>
            <div class="body-field">
              <label class="field-label">支付时间</label>
              <p class="field-content">{{DM.pay_time}}</p>
            </div>
          </div>
        </div>

        <div class="main-item-box">
          <div class="box-header">
            <span class="header-title">联系人<span class="header-subtitle">*以下信息为顾客敏感信息，飞猪已加密处理，如需查看请登录飞猪后台</span></span>
          </div>
          <div class="box-body">
            <div class="body-field">
              <label class="field-label">联系人姓名</label>
              <p class="field-content">{{DM.name}}</p>
            </div>
            <div class="body-field">
              <label class="field-label">联系电话</label>
              <p class="field-content">{{DM.phone}}</p>
            </div>
            <!-- <div class="body-field">
              <label class="field-label">邮箱</label>
              <p class="field-content">{{DM.email}}</p>
            </div> -->
            <div class="body-field">
              <label class="field-label">收货地址</label>
              <p class="field-content">{{DM.address}}</p>
            </div>
            <div class="body-field">
              <label class="field-label">买家留言</label>
              <p class="field-content">{{DM.buyer_message}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 绑定商品对话框 -->
    <bind-product :oid="oid + ''" v-model="showBindProductModal" @bindSuccess="getOtaOrder()"></bind-product>
  </div>
</template>

<script>
// import validates from '@/libs/validates';
import { mapState, mapMutations } from 'vuex';
import { SWITCH_MODAL_SHOW, PAY_OK } from '@/store/modules/follow-official-accounts/follow-official-accounts-types';

import utils from '@/libs/utils';
import Http from '@/libs/http';
import Order from '@/libs/order';
import User from '@/libs/user';

import BindProduct from './modals/bind-product';

export default {
  name: 'fliggyOrderDetail',
  components: {
    BindProduct,
  },
  data() {
    return {
      DM: Order,
      peer_account_id: '',
      oid: this.$route.params.oid,
      admin: this.$route.query.admin ? +this.$route.query.admin : 0,
      // firstPay: this.$route.query.first_pay,
      hideStaticRepayDiff: true,
      peer: User.peer || {},
      showBindProductModal: false,
      otaStatusMap: {
        2: '订单已付款',
        3: '订单已关闭',
        5: '交易成功',
      },
    };
  },
  computed: {
    ...mapState('followOA', ['mp_watch', 'payok']),
  },
  methods: {
    ...mapMutations('followOA', [SWITCH_MODAL_SHOW, PAY_OK]),

    getOtaOrder() {
      return Http.post('/ota_order_query', { ota_sub_order_id: this.oid }).then((data) => {
        this.DM = data;

        utils.extend(Order, data);

      }).catch((e) => {
        if (e) console.log(e);
      });
    },

    bindProduct() {
      this.showBindProductModal = true;
    },

  },
  mounted() {
    // 立即加入的悬浮栏的滚动事件
    window.addEventListener(
      'scroll',
      utils.debounce(() => {
        const windowHeight = document.documentElement.clientHeight;
        const bodyScrollTop =
          document.body.scrollTop || document.documentElement.scrollTop;
        const bodyScrollHeight = document.body.scrollHeight;

        if (
          windowHeight + bodyScrollTop <
          bodyScrollHeight - document.querySelector('#footer').scrollHeight
        ) {
          this.hideStaticRepayDiff = true;
        } else {
          this.hideStaticRepayDiff = false;
        }
      }, 0),
    );
  },

  beforeRouteLeave(to, from, next) {
    window.onscroll = null;
    next();
  },

  created() {
    this.getOtaOrder();

    Http.post('/peer_account_query', {}).then((data) => {
      this.peer_account_id = data.peer_account_id;
    }).catch((e) => {
      if (e) console.log(e);
    });

    if (!User.peer || !User.peer.visa_peer_id) {
      Http.post('/visa_peer_query').then((data) => {
        this.peer = data;
        User.peer = data;
      }).catch((e) => {
        if (e) console.log(e);
      });
    }
  },
};
</script>

<style lang="less" scoped>
.view-order {
  width: 920px;
  margin: auto;
  padding-bottom: 100px;

  .hierarchy {
    line-height: 56px;
  }

  .order-main {
    background-color: #fff;
    padding-bottom: 40px;
    .none-margin {
      margin-top: 0;
    }
    .module-margin {
      margin-top: 15px;
    }
    .main-header {
      padding: 0 20px;
      height: 60px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      img {
        margin-right: 10px;
        width: 25px;
        height: 25px;
      }
      span {
        font-size: 16px;
        font-weight: bold;
        color: #333;
      }
    }
    .main-tips {
      padding: 0 20px 0 46px;
      height: 40px;
      line-height: 40px;
      color: #ff5a60;
      font-size: 14px;
      background-color: #fff7f7;
      background-image: url('../../../assets/imgs/icons/warn.png');
      background-repeat: no-repeat;
      background-position: left 20px center;
    }
    .main-item-box {
      margin: 20px 20px 0;
      background-color: #ffffff;
      box-shadow: 0px 1px 4px 0px
        rgba(0, 0, 0, 0.05);
      border-radius: 4px;
      border: solid 1px #f0f0f0;
      .box-header {
        padding: 0 10px 0 20px;
        height: 56px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #f0f0f0;
        .header-title {
          font-size: 16px;
          font-weight: bold;
          color: #333;
          .header-subtitle {
            margin-left: 15px;
            font-size: 14px;
            font-weight: normal;
            color: #aaa;
          }
        }
      }
      .box-body {
        padding-top: 15px;
        padding-bottom: 5px;
        .body-field {
          padding-left: 114px;
          display: flex;
          margin-bottom: 10px;
          .field-label {
            margin-left: -96px;
            width: 96px;
            color: #777;
            font-size: 14px;
            line-height: 24px;
            flex-grow: 0;
            flex-shrink: 0;
          }

          .field-content {
            padding-right: 20px;
            font-size: 14px;
            line-height: 24px;
            color: #333;
            word-break: break-all;
            .content-subtitle {
              color: #aaa;
              margin-right: 10px;
              &.left-border::before {
                content: "";
                display: inline-block;
                vertical-align: middle;
                width: 1px;
                height: 16px;
                background-color: #cfcfcf;
                margin-right: 20px;
                margin-left: 20px;
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/orders/fliggy-order-detail/fliggyOrderDetail.vue